@if (formName) { @if ( formName.controls[inputName].invalid &&
(formName.controls[inputName].dirty || formName.controls[inputName].touched) ) {
<div class="text text-danger mt-2">
  @if (formName.controls[inputName].errors?.[errorName]) {
  <div>
    {{ errorMessage }}
  </div>
  }
</div>
} }
